import React from 'react';
import styled from 'styled-components';
import onboardingIcon from '#/static/card-icons/onboarding.png';
import offboardingIcon from '#/static/card-icons/offboarding.png';
import inspectionIcon from '#/static/card-icons/inspection.png';
import repairIcon from '#/static/card-icons/correctiveMM.png';
import scheduledmaintenanceIcon from '#/static/card-icons/scheduledMM.png';
import recallIcon from '#/static/card-icons/recall.png';
import unknownIcon from '#/static/card-icons/unknown.png';

// Define type for component props
interface WOIconRenderProps {
  type: string | null | undefined;
}

// Map of work order types to their corresponding images
const typeIconMap: Record<string, string> = {
  inspection: inspectionIcon,
  repair: repairIcon,
  maintenance: scheduledmaintenanceIcon,
  onboarding: onboardingIcon,
  offboarding: offboardingIcon,
  recall: recallIcon,
  unknown: unknownIcon, // currently returns null for unknown types
};

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  margin-right: 8px;
`;

const TypeIcon = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

/**
 * Component that renders an icon for a work order type
 */
const WOIconRender: React.FC<WOIconRenderProps> = ({ type }) => {
  const iconSrc = typeIconMap[type as string] || unknownIcon;

  return (
    <IconContainer>
      <TypeIcon src={iconSrc} alt={`${type} icon`} title={type as string} />
    </IconContainer>
  );
};

export default WOIconRender;
